import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import Logo from '../components/Logo';

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-surface-alt p-6 text-center">
      <Seo title="Page Not Found" />
      <Logo />
      <div>
        <p className="font-display text-7xl font-bold text-maroon-700">404</p>
        <h1 className="heading-brand mt-2 text-2xl">Page not found</h1>
        <p className="mt-2 text-ink-muted">The page you're looking for doesn't exist or has moved.</p>
      </div>
      <Link to="/" className="btn-primary">
        Back to home
      </Link>
    </div>
  );
}
